import { useState } from 'react';
import {
  DatePicker as MUIDatePicker,
  DatePickerProps,
} from '@mui/x-date-pickers/DatePicker';

const DatePicker = (props: DatePickerProps<any>) => {
  const [open, setOpen] = useState(false);
  return (
    <MUIDatePicker
      {...props}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      slotProps={{
        textField: {
          onClick: () => {
            setOpen(true);
          },
          ...props?.slotProps?.textField,
        },
      }}
    />
  );
};

export default DatePicker;
